import { useEffect } from 'react';

import { CLUSTERS_FIELDS } from 'shared/constants/map';
import { useGetClustersQuery } from 'shared/store/serverSide/commercial-listing-map/desktop/v2/map/get-clusters/query';

import { useGetClusterByActivePinId } from './useGetClusterByActivePinId';
import { useUpdateChangedClusters } from './useUpdateChangedClusters';

/**
 * Этот хук отслеживает изменение "clusters" в контексте активного пина.
 * Если пин выбран (т.е. показан листинг по пину), и произошел перезапрос массива "clusters", что м.б.
 * при зуме карты или её сдвиге, то нужно выставить корректные св-ва для активного пина.
 */
export function useTrackClustersChanged(): void {
  const { data } = useGetClustersQuery();
  const activeCluster = useGetClusterByActivePinId();
  const updateChangedClusters = useUpdateChangedClusters();

  useEffect(() => {
    if (activeCluster) {
      activeCluster.properties ??= {};
      activeCluster.properties[CLUSTERS_FIELDS.isActive] = 1;

      updateChangedClusters(activeCluster);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data]);
}
